'use strict';

/**
 * @usage
 *
 * <div sb-switch ng-model="isActive"></div>
 * <div sb-switch ng-disabled="true" ng-model="isDisabled"></div>
 */

function SwitchDirective ($$rAF, $parse) {

  return  {
    compile: compile,
    require: 'ngModel',
    restrict: 'AE',
    scope: {
      trueLabel: '@?',
      falseLabel: '@?'
    },
    templateUrl: 'saturn/form/switch/switch.tpl.html'
  };

  function compile ($el, $attrs) {

    $attrs.type = 'checkbox';
    $attrs.tabIndex = 0;

    // disable animation on load
    $el.addClass('disable-animations');

    // add permanent classes
    $el.addClass('sb-form-element sb-switch-container');

    // hide the outline
    $el.css({
      outline: 'none'
    });

    return link;
  }

  function link ($scope, $el, attr, ngModelCtrl) {
    var checked = false;
    var disabledGetter = $parse(attr.ngDisabled);
    // set defaults
    $scope.trueLabel = $scope.trueLabel || 'ON';
    $scope.falseLabel = $scope.falseLabel || 'OFF';

    ngModelCtrl.$render = render;

    $$rAF(function () {
      $el.removeClass('disable-animations');
    });

    if (angular.isDefined(attr.ngDisabled)) {
      $scope.$watch(disabledGetter, function (isDisabled) {
        $el.attr('tabindex', isDisabled ? -1 : 0);
      });
    }

    function render () {
      checked = ngModelCtrl.$viewValue;
      if (checked) {
        $el.addClass('checked');
      } else {
        $el.removeClass('checked');
      }
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    ///////////////////////////////////////////////////////////////////////////////////////////////

    function onClick (e) {
      if ($el[0].hasAttribute('disabled')) {
        return;
      }

      $scope.$evalAsync(function () {
        checked = !checked;
        ngModelCtrl.$setViewValue(checked, e && e.type);
        ngModelCtrl.$render();
      });
    }

    $el.on('click', onClick);
  }
}

module.exports = SwitchDirective;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/form/src/switch/SwitchDirective.js